// cacheConfig.js
export const CACHE_NAME = 'offline-cache-v1.1.5';
export const CACHE_VERSION = '1.1.5';